/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useMemo } from 'react';

import { jsx } from '@compiled/react';
import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { DEFAULT_GRAY_COLOR, isReadable } from '@atlassian/color-picker';

import { messages } from './messages';

const styles = cssMap({
	label: {
		borderRadius: token('radius.small', '3px'),
		paddingRight: token('space.050'),
		paddingLeft: token('space.050'),
	},
});

type LabelProps = {
	label?: string;
	labelColor?: string;
};

export const CardBadge = ({ label, labelColor }: LabelProps): JSX.Element => {
	const { formatMessage } = useIntl();

	const labelFinal = label || formatMessage(messages.emptyStatePlaceholderLabel);
	const labelColorFinal = labelColor ?? DEFAULT_GRAY_COLOR;

	const labelTextColorFinal = useMemo(() => {
		return isReadable(labelColorFinal, token('color.text')) ? 'color.text' : 'color.text.inverse';
	}, [labelColorFinal]);

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
		<div css={styles.label} style={{ backgroundColor: labelColorFinal }}>
			<Text color={labelTextColorFinal} size="small" maxLines={1} weight="bold">
				{labelFinal?.toUpperCase()}
			</Text>
		</div>
	);
};
